import { useEffect } from 'react'
import { useTenant } from '@emerald-works-nova/auth'
import { useParams } from 'react-router-dom'
import { useEvent } from '@emerald-works/react-event-bus-client'

export const useStackOneTrackCompletion = () => {
  const tenant = useTenant()
  const { locationId } = useParams()
  const [stackOneTrackCompletion] = useEvent([{
    eventName: 'stackOneTrackCompletion'
  }])

  const hasStackOneIntegrationEnabled = tenant?.features?.stackOne?.accountId

  useEffect(() => {
    if (!locationId || !hasStackOneIntegrationEnabled) return
    console.log('Triggering stackOneTrackCompletion event')
    stackOneTrackCompletion.trigger({
      locationId
    })
  }, [hasStackOneIntegrationEnabled, stackOneTrackCompletion, locationId])
}
